var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('uppy',{attrs:{"allowed-file-types":['application/pdf'],"endpoint":_vm.uploadPath},on:{"file-uploaded":_vm.addFile,"complete":function($event){return _vm.$emit('complete', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }